import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchJobPhases as fetchJobPhasesAPI,
  JobPhasesApiResponse,
} from '@/api/v2/jobPhases';

// Thunk to fetch job phases
export const fetchJobPhases = createAsyncThunk<
  JobPhasesApiResponse,
  string,
  { rejectValue: string }
>('v2/jobPhases/fetchJobPhases', async (jobId: string, { rejectWithValue }) => {
  try {
    const response = await fetchJobPhasesAPI(jobId);
    return response;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Failed to fetch job phases',
    );
  }
});
